import { api } from "shared/config/api/api";

import { PROMO_URL } from "./promoUrl";

import type {
  Page,
  Raffle,
  RaffleDetail,
  WheelRaffleMetadata,
} from "../model/types";

// По id бэк отдаёт один объект, по коду — страницу совпадений.
type SearchResponse = Raffle | Page<Raffle>;

const isSearchPage = (response: SearchResponse): response is Page<Raffle> =>
  "items" in response;

export const raffleDetailApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRaffle: builder.query<RaffleDetail, number>({
      query: (raffleId) => `${PROMO_URL}/wheel-raffles/${raffleId}`,
      providesTags: ["WheelRaffle"],
    }),
    // q из цифр — поиск по id, иначе по invite-коду (лимит 5 в минуту).
    searchRaffles: builder.query<Raffle[], string>({
      query: (q) => ({
        url: `${PROMO_URL}/wheel-raffles/search`,
        params: { q },
      }),
      transformResponse: (response: SearchResponse) =>
        isSearchPage(response) ? response.items : [response],
      providesTags: ["WheelRaffle"],
    }),
    getRaffleMeta: builder.query<WheelRaffleMetadata, void>({
      query: () => `${PROMO_URL}/wheel-raffles/meta`,
    }),
  }),
});

export const {
  useGetRaffleQuery,
  useLazySearchRafflesQuery,
  useGetRaffleMetaQuery,
} = raffleDetailApi;
